let grecaptchaReadyPromise = null;

export function loadRecaptcha() {
  if (window.grecaptcha) {
    return Promise.resolve(window.grecaptcha);
  }

  if (grecaptchaReadyPromise) {
    return grecaptchaReadyPromise;
  }

  grecaptchaReadyPromise = new Promise((resolve, reject) => {
    // Check if script already added
    if (!document.getElementById('recaptcha-script')) {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_KEY}`;
      script.async = true;
      script.defer = true;
      script.id = 'recaptcha-script';

      script.onload = () => {
        if (window.grecaptcha) {
          window.grecaptcha.ready(() => {
            resolve(window.grecaptcha);
          });
        } else {
          reject(new Error('grecaptcha not found after script load'));
        }
      };

      script.onerror = () =>
        reject(new Error('Failed to load recaptcha script'));

      document.head.appendChild(script);
    } else {
      // Script tag exists but grecaptcha not ready yet, wait for ready
      window.grecaptcha.ready(() => {
        resolve(window.grecaptcha);
      });
    }
  });

  return grecaptchaReadyPromise;
}
